import { CommonModule } from '@angular/common'
import { Component, Input } from '@angular/core'
import { RouterModule } from '@angular/router'
import { credits } from '@states/constants'

@Component({
  selector: 'buy-now-button',
  imports: [CommonModule, RouterModule],
  styles: `
    :host(buy-now-button) {
      display: contents;
    }
  `,
  template: `
    <a
      class="btn btn-primary"
      [ngClass]="buttonClassName"
      [routerLink]="['/sign-in']"
      rel="noopener"
    >
      &nbsp;Sign In
    </a>
  `,
})
export class BuyNowButtonComponent {
  @Input() buttonClassName?: string
  @Input() iconClassName?: string

  buyLink = credits.buyLink
}
